import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { NotificationToast } from "Components/Generic/Toast/NotificationToast";
import { useAppState } from "Context/StateContext";
import { CompanyConfig } from "Models/company.config";
import { useTranslation } from "react-i18next";
import { CompanyConfigsService } from "Services/company-configs.service";

export const useNetworkSettingsActions = () => {
  const { currentUser } = useAppState();
  const { t: translate } = useTranslation();

  const getNetworkConfigs = () => {
    return useQuery(
      ["company.configs", currentUser?.companyId],
      () =>
        CompanyConfigsService.getCurrent().then(({ data }) => {
          return data;
        }),
      {
        enabled: !!currentUser?.companyId,
        refetchOnWindowFocus: false,
      }
    );
  };

  const saveNetworkConfigs = (options: { handleSuccess?: () => void } = {}) => {
    const { handleSuccess } = options;
    return useMutation(
      ["company.configs"],
      async (payload: Partial<CompanyConfig>) => {
        const { data } = await CompanyConfigsService.saveCurrent(payload);
        return data;
      },
      {
        onSuccess: () => {
          handleSuccess?.();
        },
        onError: (error: AxiosError<any>) => {
          console.error("🚨 Network Settings SAVE failed:", error);

          if (error?.response?.data?.message) {
            NotificationToast.error(error.response.data.message);
          } else {
            NotificationToast.error(translate("failedToSaveNetworkSettings"));
          }
        },
      }
    );
  };

  return {
    getNetworkConfigs,
    saveNetworkConfigs,
  };
};
